import PropTypes from 'prop-types';
import { Button, Form, Flex, ConfigProvider } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLastStepFields } from '../fields/lastStepFields';
import { useGenerateFormItem } from '../../../utils/generateFormItem';

export const LastStep = ({
  lastStep,
  setLastStep,
  form,
  setCurrent,
  readOnly
}) => {
  const { t } = useTranslation();
  const gerenateFormItem = useGenerateFormItem();
  const { lastStepFields } = useLastStepFields();

  const handleSetLastStepData = (data) => {
    setLastStep({ ...lastStep, ...data });
  };

  return (
    <Form layout="vertical" onFinish={handleSetLastStepData} form={form}>
      <ConfigProvider componentDisabled={readOnly}>
        {lastStepFields.map((field) =>
          gerenateFormItem('owners.users_shows.review_drawer', field)
        )}
      </ConfigProvider>
      <Flex gap="small" justify="flex-end">
        <Button
          type="link"
          onClick={() => setCurrent((current) => current - 1)}
        >
          {t('buttons.previous')}
        </Button>
        <Button type="primary" htmlType="submit">
          {t(readOnly ? 'buttons.close' : 'buttons.validate')}
        </Button>
      </Flex>
    </Form>
  );
};

LastStep.propTypes = {
  form: PropTypes.shape({}).isRequired,
  lastStep: PropTypes.shape({}),
  setLastStep: PropTypes.func,
  setCurrent: PropTypes.func,
  readOnly: PropTypes.bool
};

LastStep.defaultProps = {
  lastStep: {},
  setLastStep: () => {},
  setCurrent: () => {},
  readOnly: false
};
